import { render, staticRenderFns } from "./cs-chat.vue?vue&type=template&id=de398018&scoped=true"
import script from "./cs-chat.vue?vue&type=script&lang=js"
export * from "./cs-chat.vue?vue&type=script&lang=js"
import style0 from "./cs-chat.vue?vue&type=style&index=0&id=de398018&prod&scoped=true&lang=css"
import style1 from "./cs-chat.vue?vue&type=style&index=1&id=de398018&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de398018",
  null
  
)

export default component.exports